import { validate } from '@ally/aos-utils';
export default (function (shortcode) {
    return validate(function (values) { return ({
        otpCode: [
            {
                condition: !values.otpCode,
                message: 'To continue, please enter your 6-digit security code and select continue.',
            },
            {
                condition: !!(values.otpCode && values.otpCode === shortcode),
                message: "Please enter a valid security code. The code you entered is the 5-digit 'short code' from the text message. Re-open the text message and enter the 6-digit security code found in the body of the message",
            },
            {
                condition: !!(values.otpCode &&
                    (!/^\d+$/.test(values.otpCode) || values.otpCode.length !== 6)),
                message: 'Please enter a valid, 6-digit security code (numbers only).',
            },
        ],
    }); });
});
//# sourceMappingURL=otpRules.js.map